var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      style: {
        height: "100%",
        borderRadius: "0px",
        background: "#9E1B32",
        display: "flex"
      },
      attrs: { fluid: "", "fill-height": "", id: "principal" }
    },
    [
      _c(
        "v-col",
        {
          staticClass: "ma-auto",
          attrs: { cols: "10", sm: "10", md: "10", lg: "4" }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "div",
                { staticClass: "pt-4" },
                [
                  _c("v-img", {
                    staticStyle: { margin: "auto" },
                    attrs: {
                      "align-center": "",
                      "justify-center": "",
                      src: _vm.logoRecuperiAlt,
                      width: "200px",
                      alt: "logo-recuperi"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pt-2" },
                [
                  _c("v-img", {
                    staticStyle: { margin: "auto" },
                    attrs: {
                      "align-center": "",
                      "justify-center": "",
                      src: _vm.logo,
                      width: "250px",
                      alt: "logo-recuperi"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "ma-auto", attrs: { cols: "12", lg: "10" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.checkformSubmit()
                            }
                          },
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "prepend-inner-icon": "person",
                              name: "email",
                              label: "Digite seu e-mail",
                              type: "email",
                              rules: _vm.emailRules,
                              required: "",
                              small: "",
                              solo: "",
                              "data-cy": "signinEmailField"
                            },
                            model: {
                              value: _vm.email,
                              callback: function($$v) {
                                _vm.email = $$v
                              },
                              expression: "email"
                            }
                          }),
                          _c("v-text-field", {
                            attrs: {
                              "prepend-inner-icon": "lock",
                              name: "password",
                              label: "Digite sua senha",
                              type: _vm.show1 ? "text" : "password",
                              "append-icon": _vm.show1
                                ? "mdi-eye"
                                : "mdi-eye-off",
                              "data-cy": "signinPasswordField",
                              rules: _vm.passwordRules,
                              small: "",
                              solo: "",
                              required: ""
                            },
                            on: {
                              "click:append": function($event) {
                                _vm.show1 = !_vm.show1
                              }
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "grey--text mt-4",
                              attrs: { text: "", "x-small": "", dense: "" },
                              on: {
                                click: function($event) {
                                  _vm.dialogRecuperar = !_vm.dialogRecuperar
                                }
                              }
                            },
                            [_vm._v("Esqueceu a senha?")]
                          ),
                          _c("v-checkbox", {
                            attrs: { "x-small": "", required: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      [
                                        _vm._v(
                                          " Declaro estar de acordo com os "
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function({ on }) {
                                                  return [
                                                    _c(
                                                      "a",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            target: "_blank",
                                                            href:
                                                              "https://recuperi.com.br/termos-de-uso"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            }
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " Termos de Uso "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [_vm._v(" Termos de uso ")]
                                        ),
                                        _vm._v(" , "),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function({ on }) {
                                                  return [
                                                    _c(
                                                      "a",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            target: "_blank",
                                                            href:
                                                              "https://recuperi.com.br/politica-de-privacidade"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            }
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " Política de Privacidade "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [_vm._v(" Política de Privacidade ")]
                                        ),
                                        _vm._v(" e "),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function({ on }) {
                                                  return [
                                                    _c(
                                                      "a",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            target: "_blank",
                                                            href:
                                                              "https://recuperi.com.br/codigo-de-etica"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            }
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " Código de Ética "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [_vm._v(" Código de Ética ")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ]),
                            model: {
                              value: _vm.checkboxTermos,
                              callback: function($$v) {
                                _vm.checkboxTermos = $$v
                              },
                              expression: "checkboxTermos"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "white--text",
                          attrs: {
                            color: _vm.primaryColorFont,
                            disabled: _vm.checkForm(),
                            block: "",
                            "data-cy": "signinSubmitBtn",
                            loading: _vm.load_login
                          },
                          on: { click: _vm.submit }
                        },
                        [
                          _vm._v(" Entrar "),
                          _c("v-icon", { staticClass: "ml-1" }, [
                            _vm._v("chevron_right")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.dialogRecuperar,
            callback: function($$v) {
              _vm.dialogRecuperar = $$v
            },
            expression: "dialogRecuperar"
          }
        },
        [
          _c(
            "v-card",
            [
              this.email == "" || !/.+@.+/.test(this.email)
                ? _c("v-card-text", { staticClass: "pt-5 mb-n10" }, [
                    _vm._v("Informe um e-mail válido")
                  ])
                : _c("v-card-text", { staticClass: "pt-5 mb-n10" }, [
                    _vm._v("Um e-mail será enviado para " + _vm._s(_vm.email))
                  ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  this.email != "" && /.+@.+/.test(this.email)
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "green darken-1", text: "" },
                          on: {
                            click: function($event) {
                              return _vm.enviaEmail(_vm.email)
                            }
                          }
                        },
                        [_vm._v("Enviar")]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red", text: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogRecuperar = !_vm.dialogRecuperar
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.snackbar
        ? _c("Snackbar", {
            attrs: {
              mostrarSnackbar: _vm.snackbar,
              corSnackbar: "red white--text",
              mensagemSnackbar: _vm.mensagemSnackbar
            },
            on: {
              fecharSnackbar: function($event) {
                _vm.snackbar = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }